import {makeStyles} from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  TransferCallButton: {
    fontSize: '12px',
    color: '#526FEB',
    border: '1px solid  #526FEB',
    borderRadius: '4px',
    textTransform: 'capitalize',
    width: '120px',
    height: '40px',
    marginInlineEnd: '17px',
    '&:hover': {
      backgroundColor: '#526FEB',
      color: 'white',
    },
  },
  TransferNumber: {
    color: '#526FEB',
    fontSize: '16px',
    fontWeight: '600',
    textAlign: 'center',
    latterSpacing: '0.5px',
    paddingTop: '45px',
  },
  CallConnectedIcon: {
    width: '250px',
    height: '78px',
    textAlign: 'center',
    margin: 'auto',
  },
  titleWords: {
    color: '#686D88',
    fontSize: '12px',
    fontWeight: 'normal',
    textAlign: 'center',
    paddingTop: '45px',
  },
  StatusWords: {
    color: '#39B54A',
    fontSize: '16px',
    fontWeight: '600',
    textAlign: 'center',
    marginTop: '22px',
    marginBottom: '35px',
  },
}));
